import styled from 'styled-components'

import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'
import { H3 } from 'components/Typography/Headings'
import { Font14 } from 'components/Typography'

export const ReclaimLicenseModalTitle = styled(H3)`
  margin-bottom: 16px;

  @media ${theme.devices.tablet} {
    font-size: 28px;
  }
`

export const ReclaimLicenseModalParagraph = styled.p`
  ${Font14}
  text-align: center;
  margin: ${theme.spacing.xxl} 0;
`

export const ReclaimLicenseMobileContainer = styled(WhiteBlock)`
  width: 100%;
  gap: ${theme.spacing.base};
  ${Font14}
`

export const ReclaimLicenseContentTitle = styled.div`
  ${Font14}
  font-weight: bold;
  align-items: center;
  display: flex;
  gap: ${theme.spacing.base};
  color: ${theme.colors.otterWarmBlack};
`

export const ReviewDealerNameCellContainter = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
`

export const ReclaimLicenseTableWrapper = styled.div`
  @media ${theme.devices.tablet} {
    width: max-content;
    min-width: 100%;
  }
`

export const ReviewDealerEmail = styled.span`
  ${Font14}
  text-decoration: none;
  color: ${theme.colors.horizonOrange};
  word-break: break-all;
`
